import * as actions from './actionTypes';
import initData from './initData/store';
import { pages } from './pageTypes';

function reducer(store = initData, action) {
  // if (action.type === actions.suggestedPlace) {
  //   return {
  //     ...store,
  //     state: {
  //       ...store.state,
  //       page: pages.contactWithAddress
  //     }
  //   }
  // }

  if (action.type === actions.changedMapPosition) {
    let newMap = { ...store.state.map };
    newMap[action.payload.field] = action.payload.value;

    return {
      ...store,
      state: {
        ...store.state,
        map: newMap,
      },
    };
  }

  if (action.type === actions.downloadedData) {
    let newData = { ...store.data };
    newData[action.payload.type] = action.payload.data;

    let newState = { ...store.state };
    if (action.payload.type === 'consents') {
      newState['agreements'] = action.payload.data.map((consent) => ({
        ...consent,
        checked: false,
      }));
    }

    return {
      ...store,
      state: newState,
      data: newData,
    };
  }

  if (action.type === actions.changedContactForm) {
    let newContactFormData = { ...store.state.contactForm };
    newContactFormData[action.payload.field] = {
      text: action.payload.text,
      valid: action.payload.valid,
    };

    return {
      ...store,
      state: {
        ...store.state,
        contactForm: newContactFormData,
      },
    };
  }

  if (action.type === actions.changedKnownClient) {
    let newContactFormData = { ...store.state.contactForm };
    newContactFormData[action.payload.field] = {
      text: action.payload.text,
      valid: action.payload.valid,
      value: action.payload.value,
    };

    return {
      ...store,
      state: {
        ...store.state,
        contactForm: newContactFormData,
      },
    };
  }

  if (action.type === actions.sentForm) {
    if (action.payload === 'workshop') {
      console.log('workshop form');
    }
    if (action.payload === 'generic') {
      console.log('generic form');
    }

    return {
      ...store,
      state: {
        ...store.state,
        page: pages.thankYou,
      },
    };
  }

  if (action.type === actions.changedAgreement) {
    let newAgreements = store.state.agreements.map((agr) =>
      agr.order === action.payload.order
        ? { ...agr, checked: !agr.checked }
        : { ...agr },
    );

    return {
      ...store,
      state: {
        ...store.state,
        agreements: newAgreements,
      },
    };
  }

  if (action.type === actions.changedMapFilter) {
    let newFilters = store.state.map.filters.map((filter) =>
      filter.slug === action.payload
        ? { ...filter, checked: !filter.checked }
        : { ...filter },
    );

    return {
      ...store,
      state: {
        ...store.state,
        map: {
          ...store.state.map,
          filters: newFilters,
        },
      },
    };
  }

  if (action.type === actions.loadedPage) {
    return {
      ...store,
      state: {
        ...store.state,
        page: action.payload,
      },
    };
  }

  // if (action.type === actions.clickedNextButton) {
  //   const page = action.payload
  //   let newState = {
  //     ...store.state,
  //   }

  //   let nextPage
  //   switch (page.type) {
  //     case pages.service.type: nextPage = pages.city; break
  //     case pages.city.type:    nextPage = pages.age; break
  //     case pages.age.type:
  //       nextPage = pages.map
  //       newState.map.center = null
  //       newState.map.zoom = null
  //       break

  //     case pages.map.type:     nextPage = pages.contact; break
  //     default:            break
  //   }

  //   newState.page = nextPage

  //   return {
  //     ...store,
  //     state: newState
  //   }
  // }

  // if (action.type === actions.clickedBackButton) {
  //   const page = action.payload

  //   let beforePage
  //   switch (page.type) {
  //     case pages.city.type:               beforePage = pages.service; break
  //     case pages.age.type:                beforePage = pages.city; break
  //     case pages.map.type:                beforePage = pages.age; break
  //     case pages.contact.type:            beforePage = pages.map; break
  //     case pages.contactWithAddress.type: beforePage = pages.map; break
  //     default:                            beforePage = pages.service; break
  //   }

  //   return {
  //     ...store,
  //     state: {
  //       ...store.state,
  //       page: beforePage
  //     }
  //   }
  // }

  if (action.type === actions.clearedData) {
    let newState = { ...store.state };
    let newData = { ...store.data };

    if (action.payload.type === 'state') {
      newState[action.payload.fieldName] = null;
    }

    if (action.payload.type === 'data') {
      newData[action.payload.fieldName] = null;
    }

    return {
      ...store,
      state: newState,
      data: newData,
    };
  }

  if (action.type === actions.selectedService) {
    return {
      ...store,
      state: {
        ...store.state,
        service: action.payload,
        locationId: null,
        occurrence: null,
        map: {
          ...store.state.map,
          center: null,
          zoom: null,
        },
      },
      data: {
        ...store.data,
        workshops: null,
      },
    };
  }

  if (action.type === actions.selectedCity) {
    return {
      ...store,
      state: {
        ...store.state,
        city: action.payload,
        // robot: null,

        locationId: null,
        occurrence: null,
        map: {
          ...store.state.map,
          center: null,
          zoom: null,
        },
      },
      data: {
        ...store.data,
        workshops: null,
      },
    };
  }

  if (action.type === actions.selectedAge) {
    return {
      ...store,
      state: {
        ...store.state,
        age: action.payload,
        robot: null,
      },
    };
  }

  if (action.type === actions.selectedRobot) {
    return {
      ...store,
      state: {
        ...store.state,
        robot: action.payload,

        locationId: null,
        occurrence: null,
        map: {
          ...store.state.map,
          center: null,
          zoom: null,
        },
      },
      data: {
        ...store.data,
        workshops: null,
      },
    };
  }

  if (action.type === actions.selectedLocation) {
    return {
      ...store,
      state: {
        ...store.state,
        locationId: action.payload,
        occurrence: null,
      },
    };
  }

  if (action.type === actions.selectedOccurrence) {
    return {
      ...store,
      state: {
        ...store.state,
        occurrence: action.payload,
      },
    };
  }

  if (action.type === actions.closedTip) {
    let newTips = { ...store.state.tips };
    newTips[action.payload] = false;

    return {
      ...store,
      state: {
        ...store.state,
        tips: newTips,
      },
    };
  }

  return store;
}

export default reducer;
